var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_206_56",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_206_56",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAABjElEQVRYhe1X0W2DMBB9rfrfbFBG8AZhBDpBGYFuwAZlBDboCmSDjJBs4ExwlaWzcgUbn1MIldonWTKyffd4fofNAxFhSzxumv3PE9AQKAD0ACwAymyW1xazGZwJI62l5dDE8sSqoAHwIZ4PAIZMdUsAe/H8DqDTKFCI97ZEVM2olGoVx/AoxvNDAXqx4Nbkhog6upLw6DUEPONBkcQFr4moHCnoY3gSg1A0ScCjjSR2SU8Be56E2byKNU0N/SMCPaXRC4WQIvCU4eoKwBv3L+xoXxklV84zzzkGHR9ChgJedjt6O+kJK+ZAo4D2U2wAvHC/4zcc48gqgJUoNYG1BHaiP/dBkmNmSQKrQUvAiv6ctHIstE0TaAm4YGfuNxF5jXD+RXt25JShS/zJBhtmytChVUdd8UO0aBl61ABexXZInPnIrXMChu4DlqU8JAxnxG3HKspzz97YfRtZ6TgeH17R7QktuOuF5FdeyXxrFI7XInopTUlY8L7ZG5JaXjuRXbMFd8P/v+G2BAB8AfAbTo2c3XoDAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fcbaf0608a4e809c61c7b25f75efab9b.svg";
export { ForwardRef as ReactComponent };